const Child = () => {
    return (
        <div>Example Child 01</div>
    )
}

export default Child